import Navbar from "@base/Navbar/Navbar"

export default Navbar;
